import React from "react";

const ReportBug = () => {
  return (
    <div>
      <h1 className="text-2xl font-semibold">Report Bug</h1>
    </div>
  );
};

export default ReportBug;
